import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import PublicPageHeader from '../components/PublicPageHeader';

const ContactPage = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: 'background.default' }}>
      <PublicPageHeader title="Contact Us" />
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h1" component="h2" gutterBottom fontWeight="bold" textAlign="center" sx={{ fontSize: { xs: '1.8rem', md: '2.5rem' } }}>
          Contact Us
        </Typography>
        <Typography variant="h2" component="h2" textAlign="center" color="text.secondary" sx={{ mb: 4 }}>
          We'd love to hear from you. Reach out anytime!
        </Typography>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <EmailIcon color="primary" />
            <Box sx={{ flex: 1 }}>
              <Typography variant="h3" component="h3">Email</Typography>
              <Button
                component="a"
                href="mailto:support@earn-echore.app"
                variant="outlined"
                size="medium"
                startIcon={<EmailIcon />}
                sx={{
                  mt: 0.5,
                  minHeight: '48px',
                  textTransform: 'none',
                  fontSize: '0.95rem',
                  borderRadius: 2,
                  wordBreak: 'break-all',
                  whiteSpace: 'normal',
                  textAlign: 'left',
                  px: 2,
                }}
              >
                support@earn-echore.app
              </Button>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <PhoneIcon color="primary" />
            <Box sx={{ flex: 1 }}>
              <Typography variant="h3" component="h3">Phone</Typography>
              <Button
                component="a"
                href="tel:+12192800438"
                variant="outlined"
                size="medium"
                startIcon={<PhoneIcon />}
                sx={{
                  mt: 0.5,
                  minHeight: '48px',
                  textTransform: 'none',
                  fontSize: '0.95rem',
                  borderRadius: 2,
                  wordBreak: 'break-all',
                  whiteSpace: 'normal',
                  textAlign: 'left',
                  px: 2,
                }}
              >
                +1-219-280-0438
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ContactPage;
